import React from "react";
import PropTypes from "prop-types";
import { useClasses } from "@xo-union/react-css-modules";
import classesPropType from "@xo-union/classes-prop-type";
import ScreenReaderPrefix from "../ScreenReaderPrefix.js";
import styles from "../../css/index.css";
const Alert = props => {
  const {
    children,
    type,
    position,
    visible,
    classes: classesProp,
    id
  } = props;
  const classes = useClasses(styles, classesProp);
  const typeClassMap = {
    error: classes['type-error'],
    info: classes['type-info']
  };
  const positionClassMap = {
    top: classes['position-top'],
    bottom: classes['position-bottom']
  };
  const baseClass = classes.container || '';
  const visibility = visible ? 'is-visible' : 'is-not-visible';
  const visibleClass = classes[visibility] || '';
  const typeClass = typeClassMap[type] || '';
  const positionClass = positionClassMap[position] || '';
  const role = visible ? 'alert' : 'none';
  const live = visible ? 'polite' : 'off';
  const ariaHidden = !visible;
  return /*#__PURE__*/React.createElement("div", {
    role: role,
    "aria-live": live,
    "aria-hidden": ariaHidden,
    id: id,
    className: `${baseClass} ${typeClass} ${positionClass} ${visibleClass}`
  }, /*#__PURE__*/React.createElement(ScreenReaderPrefix, {
    type: type
  }), children);
};
Alert.defaultProps = {
  position: 'top',
  type: 'error'
};
process.env.NODE_ENV !== "production" ? Alert.propTypes = {
  /**
   * Contents of alert
   */
  children: PropTypes.node,
  /**
   * Type of alert (Currently, error and info are the only supported types)
   */
  type: PropTypes.oneOf(['error', 'info']),
  /**
   * Position in container
   */
  position: PropTypes.oneOf(['top', 'bottom']),
  /**
   * Should the alert be visible
   */
  visible: PropTypes.bool,
  /**
   * Class dependencies
   */
  classes: classesPropType(['container', 'is-visible', 'is-not-visible', 'type-error', 'type-info', 'position-top', 'position-bottom']),
  /**
   * ID of the alert component
   */
  id: PropTypes.string
} : void 0;
export default Alert;